export class ComplaintSearch {
    public states: number[];
    public complaintTypes: string[];
    public dateFrom: Date;
    public dateTo: Date;
    public searchValue: string;
}
